/* NANIORA theme — small, dependency-free enhancements. Everything works without it. */
(function () {
  'use strict';

  /* Bind a behaviour to each matching element once, even when the theme editor re-renders a section */
  function each(root, selector, fn) {
    root.querySelectorAll(selector).forEach(function (el) {
      var key = 'bound' + fn.name;
      if (el.dataset[key]) return;
      el.dataset[key] = '1';
      fn(el);
    });
  }

  /* ---------- Delegated: work for any element, now or later ---------- */

  /* Quantity steppers (product page and bag) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10)));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Copy a coupon code */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b || !navigator.clipboard) return;
    navigator.clipboard.writeText(b.getAttribute('data-copy')).then(function () {
      var label = b.textContent;
      b.textContent = 'Copied';
      setTimeout(function () { b.textContent = label; }, 2000);
    });
  });

  /* ---------- Per-element behaviours ---------- */

  /* Bag: save quantity changes automatically */
  function cartForm(form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      var mx = e.target.max ? parseInt(e.target.max, 10) : Infinity;
      if (parseInt(e.target.value, 10) > mx) e.target.value = mx;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 500);
    });
    var updateBtn = form.querySelector('[data-update-button]');
    if (updateBtn) updateBtn.hidden = true;
  }

  /* Collection: sort without a submit button */
  function sortSelect(select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
    var btn = select.form && select.form.querySelector('[data-sort-submit]');
    if (btn) btn.hidden = true;
  }

  /* Collection filter panel */
  function filterToggle(btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      if (!open) { var first = panel.querySelector('input'); if (first) first.focus(); }
    });
  }

  /* Product gallery: swipe counter on phones, thumbnails on desktop */
  function gallery(el) {
    var track = el.querySelector('.gallery__track');
    var slides = el.querySelectorAll('.gallery__slide');
    var count = el.querySelector('[data-gallery-count]');
    var thumbs = el.querySelectorAll('.gallery__thumb');
    if (!track || !slides.length) return;

    function setCurrent(i) {
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        setCurrent(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setCurrent(i);
      });
    });
    setCurrent(0);
  }

  /* Product: variant picker updates price and button */
  function variantSelect(select) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = opt.getAttribute('data-price');
      var available = opt.getAttribute('data-available') === 'true';
      document.querySelectorAll('[data-product-price]').forEach(function (el) { el.textContent = price; });
      document.querySelectorAll('[data-add-button]').forEach(function (b) {
        b.disabled = !available;
        b.textContent = available ? b.getAttribute('data-label-add') : b.getAttribute('data-label-soldout');
      });
      /* Sold-out option: offer "Notify me", tagged for this exact option */
      document.querySelectorAll('[data-notify]').forEach(function (n) {
        n.hidden = available;
        var tags = n.querySelector('[data-notify-tags]');
        var vh = opt.getAttribute('data-variant-handle');
        if (tags && n.getAttribute('data-single-variant') !== 'true' && vh) {
          tags.value = 'notify-me, ' + n.getAttribute('data-notify-base') + ':' + vh;
        }
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* Product: "Notify me" for sold-out sarees.
     One click = one request: the button locks while sending, a saree already requested from this
     browser is not sent again, and any second request within a few seconds is held back.
     (The shop also collapses repeats: same email + same tag is one customer.) */
  function notifyForm(form) {
    var KEY = 'naniora-notify', REPEAT_MS = 30 * 24 * 3600 * 1000, COOLDOWN_MS = 15 * 1000;
    var btn = form.querySelector('[data-notify-submit]');
    var msg = form.querySelector('[data-notify-msg]');
    var tags = form.querySelector('[data-notify-tags]');
    var hp = form.querySelector('[data-notify-hp]');
    var busy = false;
    if (!btn) return;

    function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (err) { return {}; } }
    function write(data) { try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (err) { /* private mode: server still collapses repeats */ } }
    function say(text) { msg.textContent = text; msg.hidden = false; }
    function done(text) {
      var wrap = form.querySelector('.inline-form');
      if (wrap) wrap.hidden = true;
      var intro = form.querySelector('.notify__text');
      if (intro) intro.hidden = true;
      say(text);
    }

    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      if (!window.fetch || !window.FormData) return;           /* no fetch: normal form post */
      e.preventDefault();
      if (!form.reportValidity()) return;
      if (hp && hp.value) { done("Done. We'll write to you the moment it's back."); return; }   /* bot: look happy, send nothing */

      var seen = read(), now = Date.now(), key = tags.value, last = 0, k;
      for (k in seen) { if (seen[k] > last) last = seen[k]; }
      if (seen[key] && now - seen[key] < REPEAT_MS) { done("You're already on the list for this one. We'll write when it's back."); return; }
      if (now - last < COOLDOWN_MS) { say('One moment, please, then try again.'); return; }

      busy = true; btn.disabled = true; msg.hidden = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (res) {
          if (res.url.indexOf('/challenge') > -1) { busy = false; form.submit(); return; }   /* shop asks for a captcha: let the page do it */
          if (!res.ok) throw new Error('not posted');
          seen[key] = now; write(seen);
          done("Done. We'll write to you the moment it's back.");
        })
        .catch(function () { busy = false; btn.disabled = false; say('Sorry, that did not go through. Please try again.'); });
    });
  }

  /* Product: sticky "Add to bag" on phones once the main button scrolls away */
  function stickyAdd(sticky) {
    var mainAdd = document.querySelector('[data-main-add]');
    if (!mainAdd) return;
    var raf, shown = null;
    /* Measured on every scroll (throttled to a frame) so fast flings and jumps never leave it stuck */
    function update() {
      var show = mainAdd.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sticky.inert = !show;
    }
    window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Menu drawer: close on Escape and on overlay tap */
  function menuDrawer(d) {
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) { d.open = false; d.querySelector('summary').focus(); }
    });
    d.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); d.open = false; });
    });
    d.addEventListener('toggle', function () {
      document.documentElement.style.overflow = d.open ? 'hidden' : '';
    });
  }

  /* Home: the elephants arrive in the header once the banner's logo has scrolled away */
  function headerReveal(header) {
    if (!header.classList.contains('site-header--reveal')) return;
    var link = header.querySelector('[data-header-logo]');
    var target = document.querySelector('.hero__logo') || document.querySelector('[data-hero]');
    function set(on) {
      header.classList.toggle('is-revealed', on);
      if (link) { if (on) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1'); }
    }
    if (!target || !('IntersectionObserver' in window)) { set(true); return; }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      set(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { rootMargin: '-' + header.offsetHeight + 'px 0px 0px 0px' }).observe(target);
  }

  /* Moments: the arched picture follows the row you point at or tab to */
  function moments(section) {
    var rows = section.querySelectorAll('[data-moment-index]');
    var imgs = section.querySelectorAll('[data-moment-img]');
    function show(i) {
      rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-moment-index') === i); });
      imgs.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-moment-img') === i); });
    }
    rows.forEach(function (r) {
      var i = r.getAttribute('data-moment-index');
      r.addEventListener('mouseenter', function () { show(i); });
      r.addEventListener('focus', function () { show(i); });
    });
  }

  /* Reveal on scroll: only when the layout opted in (never in the theme editor) */
  var revealer = null;
  function reveal(el) {
    if (!document.documentElement.classList.contains('js-reveal')) return;
    if (!revealer) {
      revealer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealer.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    revealer.observe(el);
  }

  /* Any link that leaves the shop (WhatsApp, Instagram, menu links, links in rich text) opens in a new tab */
  function externalLinks(root) {
    root.querySelectorAll('a[href]').forEach(function (a) {
      var proto = a.protocol;
      if (proto !== 'http:' && proto !== 'https:') return;     /* mailto:, tel: and #anchors stay as they are */
      if (a.hostname === window.location.hostname) return;
      if (/(^|\.)(myshopify\.com|shopify\.com)$/.test(a.hostname)) return;   /* the shop's own checkout and account pages stay in this tab */
      if (!a.target) a.target = '_blank';
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      ['noopener', 'noreferrer'].forEach(function (r) { if (rel.indexOf(r) < 0) rel.push(r); });
      a.setAttribute('rel', rel.join(' '));
    });
  }

  function init(root) {
    externalLinks(root);
    each(root, '#cart-form', cartForm);
    each(root, '[data-sort-select]', sortSelect);
    each(root, '[data-filter-toggle]', filterToggle);
    each(root, '[data-gallery]', gallery);
    each(root, '[data-variant-select]', variantSelect);
    each(root, '[data-notify] form', notifyForm);
    each(root, '[data-sticky-atc]', stickyAdd);
    each(root, '[data-menu-drawer]', menuDrawer);
    each(root, '[data-header]', headerReveal);
    each(root, '[data-moments]', moments);
    each(root, '.reveal', reveal);
  }

  init(document);
  window.nanioraReveal = true;

  /* Theme editor: re-run on sections that are added or re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
